
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-centers-capabilities",
      function () {
        return require("private-next-pages/data-centers-capabilities.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-centers-capabilities"])
      });
    }
  